"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrganicListing = function OrganicListing(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link;
  return _react2.default.createElement(
    "div",
    { className: "spacer" },
    _react2.default.createElement(
      "div",
      { className: "organic-listing loading", id: "siteTable_organic" },
      _react2.default.createElement(
        "div",
        { className: "help help-hoverable" },
        "what's this?",
        _react2.default.createElement(
          "div",
          {
            className: "hover-bubble help-bubble anchor-top",
            id: "spotlight-help"
          },
          _react2.default.createElement(
            "div",
            { className: "help-section help-promoted" },
            _react2.default.createElement(
              "p",
              null,
              "This sponsored link is an advertisement generated with our",
              " ",
              _react2.default.createElement(
                Link,
                { href: "https://www.reddit.com/wiki/selfserve" },
                "self-serve advertisement tool"
              ),
              "."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Use of this tool is open to all members of reddit.com, and for as little as $5.00 you can advertise in this area.",
              " ",
              _react2.default.createElement(
                "a",
                { href: "/advertising" },
                "Get started \u203A"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "help-section help-organic" },
            _react2.default.createElement(
              "p",
              null,
              "This area shows new and upcoming links. Vote on links here to help them become popular, and click the forwards and backwards buttons to view more."
            ),
            _react2.default.createElement(
              "form",
              { action: "#", className: "toggle disable_ui-button", method: "get" },
              _react2.default.createElement("input", {
                name: "executed",
                type: "hidden",
                defaultValue: "This element has been disabled."
              }),
              _react2.default.createElement("input", { name: "id", type: "hidden", defaultValue: "organic" }),
              _react2.default.createElement(
                "span",
                { className: "option main active" },
                "Click ",
                _react2.default.createElement(
                  "a",
                  { className: "togglebutton access-required" },
                  "here"
                ),
                " to disable this feature."
              ),
              _react2.default.createElement(
                "span",
                { className: "option error" },
                "are you sure? ",
                _react2.default.createElement(
                  "a",
                  { className: "yes" },
                  "yes"
                ),
                " / ",
                _react2.default.createElement(
                  "a",
                  { className: "no" },
                  "no"
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "help-section help-interestbar" },
            _react2.default.createElement(
              "p",
              null,
              "Enter a keyword or topic to discover new subreddits around your interests. Be specific!"
            ),
            _react2.default.createElement(
              "p",
              null,
              "You can access this tool at any time on the",
              " ",
              _react2.default.createElement(
                "a",
                { href: "/subreddits/" },
                "/subreddits/"
              ),
              " page."
            )
          )
        )
      )
    )
  );
};

exports.default = OrganicListing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/OrganicListing.js
// module id = 309
// module chunks = 0